import React, {Component} from "react"
import {weiChatAuthor} from "../config/config";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux'
import * as userAction from '../reduxModule/actions/user'
import storage from '../utils/localStore';
import {getUserInfo,} from "../service/homeService";
import {addContact} from "../service/memberService";
import BindingModal from "../components/BindingModal";
import RealNameModal from "../components/RealNameModal";
import ExigencyPep from "../components/ExigencyPep";
import {Toast} from "antd-mobile";
let arr = window.location.search.substring(1).split('&');
@connect(
    state => ({userInfo: state.userInfo}),
    dispatch=>({
        ...bindActionCreators(userAction,dispatch)
    })
)
export default class WeChatLogin extends Component {
    constructor(props) {
          super(props);
          this.state = {
              bindingModal:false,
              phone:"",
              realNameModal:false,
              realName:"",
              exigencyModal:false,
              token:"",
          }
      }


    componentDidMount() {
        if(window.location.href.split('id=')[1]){
            sessionStorage.setItem('codeId',window.location.href.split('id=')[1])
        }
        if(window.location.href.split('source=')[1] == undefined){
            return
        }
        if(document.location.search.indexOf('token=') === -1){
            window.location.href = weiChatAuthor(`${this.props.match.params.typeName}?source=${arr[0].split('=')[1]}`)
        }else{
            sessionStorage.setItem('sourceAccountId',arr[0].split('=')[1]);
            this.getUserInfo(arr[1].split('=')[1]);
        }

    }
    judgeToken(){
        // 判断用户是否是第一次进入，是：授权
        if((this.props.userInfo.token === undefined || this.props.userInfo.token === '' || this.props.userInfo.token === null )&& document.location.search.indexOf('token=') === -1){
            window.location.href = weiChatAuthor(this.props.match.params.typeName)
        }
        // 如果授权过且本地没存token,获取用户信息，存token
        if((this.props.userInfo.token === '' || this.props.userInfo.token === undefined ) && document.location.search.indexOf('token=') !== -1){
            this.getUserInfo(window.location.href.split('token=')[1]);
        }
        //如果已存过token,拿存的token获取用户信息判断token是否刷新,没刷新不操作，如果返回过期，清除token
        if(this.props.userInfo.token !== '' && this.props.userInfo.token !== undefined){
            this.getUserInfo(this.props.userInfo.token)
        }
    }

    getUserInfo(token){
        getUserInfo({token:token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                let usr = {
                    token:token,
                    phone: res.data.data.phone,
                    openid: res.data.data.openid,
                    nickname:res.data.data.nickname,
                    avatar:res.data.data.avatar,
                    integral:res.data.data.integral,
                    emergencyContact:res.data.data.emergencyContact,
                    idNum:res.data.data.idNum,
                    couponCount:res.data.data.couponCount,
                    userId:res.data.data.id,
                    isSalesman:res.data.data.isSalesman,
                    walletStatus:res.data.data.walletStatus,
                    signStatus:res.data.data.signStatus,
                };
                storage.setItem('usr', usr);
                this.props.userLogin(usr);
                this.getPhone(res.data.data)
            }else if(res.data.code === '1401'){
                this.props.userLoginOut();
                window.location.reload()
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    getPhone(data){
        if(this.props.userInfo.isLoggedIn){
            if(this.props.match.params.typeName === 'bindingpage'){
                this.props.history.push('/identityBinding');
                return
            }
            if(data.phone == null || data.phone == ""){
                this.setState({bindingModal:true});
                return
            }
            if(data.idNum == null || data.idNum == ""){
                this.setState({realNameModal:true});
                return
            }
            if(data.emergencyContact == null ||  data.emergencyContact == "" ){
                this.setState({exigencyModal:true});
                return
            }
            this.goToPage()
        }
    }
    goToPage(){
        this.setState({exigencyModal:false,realNameModal:false,bindingModal:false});
        if(this.props.match.params.typeName === 'homepage'){
            sessionStorage.setItem('bgImg','no');
            this.props.history.push('/pay/home');
        }
        if(this.props.match.params.typeName === 'memberpage'){
            this.props.history.push('/pay/myPage');
        }
        if(this.props.match.params.typeName === 'mtLifepage'){
            this.props.history.push('/mtLife');
        }
    }
    onClose = (type) => {
        if(type == "first"){
            this.goToPage()
        }
        this.setState({bindingModal:false,realNameModal:false,exigencyModal:false});
    };
    bindingClick(item){
        this.setState({phone:item});
        this.getUserInfo(this.props.userInfo.token)
    }
    realNameClick(item){
        this.setState({exigencyModal:true,realName:item});
    }
    exigencyClick(params){
        addContact(params).then((res)=>{
            if(res.data.code === '0000'){
                let usr = {
                    token:this.props.userInfo.token,
                    phone: this.state.phone,
                    openid: this.props.userInfo.openid,
                    nickname:this.props.userInfo.nickname,
                    avatar:this.props.userInfo.avatar,
                    integral:this.props.userInfo.integral,
                    emergencyContact:params.data.userName,
                    idNum:this.state.realName,
                    couponCount:this.props.userInfo.couponCount,
                    userId:this.props.userInfo.id,
                };
                storage.setItem('usr', usr);
                this.props.userLogin(usr);
                Toast.info('添加成功',2,()=>this.goToPage());
            }else{
                Toast.info(res.data.msg,3)
            }
        });


    }
    render() {
        return (
            <div>
                <BindingModal
                    modal={this.state.bindingModal}
                    onClose={this.onClose.bind(this)}
                    bindingClick = {this.bindingClick.bind(this)}
                    {...this.props}
                />
                <RealNameModal
                    modal={this.state.realNameModal}
                    onClose={this.onClose.bind(this)}
                    realNameClick = {this.realNameClick.bind(this)}
                    {...this.props}
                />
                <ExigencyPep
                    modal={this.state.exigencyModal}
                    onClose={this.onClose.bind(this)}
                    exigencyClick = {this.exigencyClick.bind(this)}
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/WeChatLogin.js